var AES  = require('./aes.js')
var ble_config = {
	UUID_SERVICE: "49535343-fe7d-4ae5-8fa9-9fafd205e455",
	UUID_WRITE: "49535343-8841-43f4-a8d4-ecbe34729bb3",
	UUID_NOTIFY: "49535343-1e4d-4bd9-ba61-23c647249616",
	VERIFY_KEY: '7e3mmjjbVANsiMz5',
	CMD_VERSION: '7'.charCodeAt(0),
	CMD_SEND_RAND: 'O'.charCodeAt(0),
	CMD_VERIFY: 'P'.charCodeAt(0),
	CMD_OPEN_DOOR: 'Q'.charCodeAt(0),
	CMD_WRITE_KEY: 'M'.charCodeAt(0),
	CMD_SET_TIME: 'A'.charCodeAt(0),
	CMD_WRITE_PARAM: 'L'.charCodeAt(0),
	CMD_BIND: 'S'.charCodeAt(0),
	CMD_ENABLE_BRUSH: '4'.charCodeAt(0),
	CMD_RECEIVE_CARD: '5'.charCodeAt(0),
	CMD_SET_WIFI_SSID: 'a'.charCodeAt(0),
	CMD_SET_WIFI_PASS: 'b'.charCodeAt(0),
	AC_SET_MQTT_DOMAIN: '2'.charCodeAt(0),
	AC_X1000_CMD: 'f'.charCodeAt(0),
	AC_X1000_CMD_SET_NETWORK_INFO: 14,
	AC_X1000_CMD_SET_WIFI_MODE: 16,
	AC_X1000_CMD_SET_WIFI_SSID: 17,
	AC_X1000_CMD_SET_WIFI_PASS: 18,
	AC_X1000_CMD_ENABLE_4G: 22,
	AC_X1000_CMD_SET_NETWORK_TYPE: 23,
	AC_X1000_CMD_SET_LOCAL_SERVER: 24,
	CMD_CONTINUE: 0x90,
	CMD_FINISH: 0x91,
};
var ble_command = {
	keyRand: new ArrayBuffer(16),
	keyDevice: new ArrayBuffer(16),
	isKeySetted: false,
	init: function() {
		this.isKeySetted = false;
		let k1 = new Uint8Array(this.keyRand);
		let k2 = new Uint8Array(this.keyDevice);
		for (var i = 0; i < 16; i++) {
			k1[i] = Math.floor(Math.random() * (255 + 1));
			k2[i] = 0;
		}
	},
	setKey: function(key, offset) {
		let len = key.length || key.byteLength || 0;
		if ((len - offset) >= 16) {
			this.isKeySetted = true;
			var k1 = key.length ? key : new Uint8Array(key);
			let k2 = new Uint8Array(this.keyDevice);
			for (var i = 0; i < 16; i++) {
				k2[i] = k1.charCodeAt(i + offset);
			}
		}
	},
	getVersionCommand: function() {
		let data = new ArrayBuffer(20);
		let bytes = new Uint8Array(data);
		for (var i = 0; i < data.byteLength; i++) {
			bytes[i] = 0xFF;
		}
		bytes[0] = 0x02;
		bytes[1] = 0x14;
		bytes[2] = ble_config.CMD_VERSION;
		bytes[19] = 0x03;
		return data;
	},
	sendRandCommand: function() {
		let data = new ArrayBuffer(20);
		let bytes = new Uint8Array(data);
		bytes[0] = 0x02;
		bytes[1] = 0x14;
		bytes[2] = ble_config.CMD_SEND_RAND;
		let k1 = new Uint8Array(this.keyRand);
		for (var i = 3; i < data.byteLength - 1; i++) {
			bytes[i] = k1[i];
		}
		bytes[19] = 0x03;
		return data;
	},
	writeKeyCommand: function(key) {
		let data = new ArrayBuffer(20);
		let bytes = new Uint8Array(data);
		bytes[0] = 0x02;
		bytes[1] = 0x14;
		bytes[2] = ble_config.CMD_WRITE_KEY;
		if (typeof(key) == "object") {
			if (key.length == 16) {
				for (var i = 3; i < data.byteLength - 1; i++) {
					bytes[i] = key[i];
				}
			} else if (key.byteLength == 16) {
				let k1 = new Uint8Array(key);
				for (var i = 3; i < data.byteLength - 1; i++) {
					bytes[i] = k1[i];
				}
			} else {
				throw "Key必须是16字节";
			}
		} else if (typeof(key) == "string" && key.length == 16) {
			for (var i = 3; i < data.byteLength - 1; i++) {
				bytes[i] = key.charCodeAt(i - 3);
			}
		} else {
			throw "Key格式不对";
		}
		bytes[19] = 0x03;
		this.setKey(key, 0);
		return data;
	},
	verifyCommand: function(deviceRand, key) {
		let data = new ArrayBuffer(20);
		let bytes = new Uint8Array(data);
		bytes[0] = 0x02;
		bytes[1] = 0x14;
		bytes[2] = ble_config.CMD_VERIFY;
		if (typeof(key) == "string" && deviceRand.byteLength == 16 && key.length == 16) {
			let k1 = new Uint8Array(deviceRand);
			let k2 = new Uint8Array(16);
			for (var i = 0; i < 16; i++) {
				k2[i] = key.charCodeAt(i);
			}
			let r = AES.encrypt(k1, k2);
			for (var i = 3; i < bytes.byteLength - 1; i++) {
				bytes[i] = parseInt(r.substr((i - 3) * 2, 2), 16);
			}
		} else if (deviceRand.byteLength == 16 && key.byteLength == 16) {
			let k1 = new Uint8Array(deviceRand);
			let k2 = new Uint8Array(key);
			let r = AES.encrypt(k1, k2);
			for (var i = 3; i < bytes.byteLength - 1; i++) {
				bytes[i] = parseInt(r.substr((i - 3) * 2, 2), 16);
			}
		} else {
			throw "Key必须是16字节";
		}
		bytes[19] = 0x03;
		return data;
	},
	openDoorCommand: function(isValid, cardId, feature) {
		if (typeof(cardId) != "string" || typeof(feature) != "string") {
			throw "参数格式不正确";
		}
		if (cardId.length != 8 && feature.length != 4) {
			throw "参数格式不正确";
		}
		if (!this.isKeySetted) {
			throw "未设置密钥";
		}
		let k1 = new Uint8Array(16);
		k1[0] = isValid ? 1 : 0;
		for (var i = 1; i <= 4; i++) {
			k1[i] = parseInt(cardId.substr((i - 1) * 2, 2), 16);
		}
		for (var i = 5; i < 7; i++) {
			k1[i] = parseInt(feature.substr((i - 5) * 2, 2), 16);
		}
		for (var i = 7; i < k1.byteLength; i++) {
			k1[i] = 0xFF;
		}
		let k2 = new Uint8Array(this.keyDevice);
		let r = AES.encrypt(k1, k2);
		let data = new ArrayBuffer(20);
		let bytes = new Uint8Array(data);
		bytes[0] = 0x02;
		bytes[1] = 0x14;
		bytes[2] = ble_config.CMD_OPEN_DOOR;
		for (var i = 3; i < bytes.byteLength - 1; i++) {
			bytes[i] = parseInt(r.substr((i - 3) * 2, 2), 16);
		}
		bytes[19] = 0x03;
		return data;
	},
	setTimeCommand: function(date) {
		let data = new ArrayBuffer(20);
		let bytes = new Uint8Array(data);
		var offset = date.getTimezoneOffset() / 60 + 12;
		bytes[0] = 0x02;
		bytes[1] = 0x14;
		bytes[2] = ble_config.CMD_SET_TIME;
		bytes[3] = parseInt(date.getFullYear() - 2000, 16);
		bytes[4] = parseInt(date.getMonth() + 1, 16);
		bytes[5] = parseInt(date.getDate(), 16);
		bytes[6] = parseInt(date.getHours(), 16);
		bytes[7] = parseInt(date.getMinutes(), 16);
		bytes[8] = parseInt(date.getSeconds(), 16);
		bytes[9] = parseInt(date.getDay(), 16);
		bytes[10] = offset & 0xFF;
		bytes[19] = 0x03;
		return data;
	},
	bindCommand: function(distance, type, rand, timezone, userData) {
		let data = new ArrayBuffer(20);
		let bytes = new Uint8Array(data);
		bytes[0] = 0x02;
		bytes[1] = 0x14;
		bytes[2] = ble_config.CMD_BIND;
		bytes[3] = (distance << 4 | (type & 0xF)) & 0xFF;
		bytes[4] = timezone & 0xFF;
		bytes[5] = rand & 0xFF;
		bytes[6] = (rand >> 8) & 0xFF;
		bytes[7] = (rand >> 16) & 0xFF;
		if (userData) {
			for (var i = 0; i < Math.min(11, userData.length); i++) {
				bytes[8 + i] = userData.charCodeAt(i);
			}
		}
		bytes[19] = 0x03;
		return data;
	},
	writeParamCommand: function(inOut, openDelay, openWay) {
		let data = new ArrayBuffer(20);
		let bytes = new Uint8Array(data);
		bytes[0] = 0x02;
		bytes[1] = 0x14;
		bytes[2] = ble_config.CMD_WRITE_PARAM;
		bytes[3] = inOut ? 1 : 0;
		bytes[4] = openDelay & 0xFF;
		bytes[5] = openWay & 0xFF;
		bytes[19] = 0x03;
		return data;
	},
	enableBrushCardCommand: function(enabled) {
		let data = new ArrayBuffer(20);
		let bytes = new Uint8Array(data);
		bytes[0] = 0x02;
		bytes[1] = 0x14;
		bytes[2] = ble_config.CMD_ENABLE_BRUSH;
		bytes[3] = enabled ? 1 : 0;
		bytes[19] = 0x03;
		return data;
	},
	setWifiSSIDCommand: function(ssid) {
		if (!ssid) {
			throw "未设置ssid";
		}
		let data = new ArrayBuffer(20);
		let bytes = new Uint8Array(data);
		bytes[0] = 0x02;
		bytes[1] = 0x14;
		bytes[2] = ble_config.CMD_SET_WIFI_SSID;
		for (var i = 0; i < Math.min(16, ssid.length); i++) {
			bytes[3 + i] = ssid.charCodeAt(i);
		}
		bytes[19] = 0x03;
		return data;
	},
	setWifiPasswordCommand: function(password) {
		if (!password) {
			throw "未设置password";
		}
		let data = new ArrayBuffer(20);
		let bytes = new Uint8Array(data);
		bytes[0] = 0x02;
		bytes[1] = 0x14;
		bytes[2] = ble_config.CMD_SET_WIFI_PASS;
		for (var i = 0; i < Math.min(16, password.length); i++) {
			bytes[3 + i] = password.charCodeAt(i);
		}
		bytes[19] = 0x03;
		return data;
	},
	setWifiSSIDCommand2: function(ssid) {
		if (!ssid) {
			throw "未设置ssid";
		}
		let data = new ArrayBuffer(20);
		let bytes = new Uint8Array(data);
		bytes[0] = 0x02;
		bytes[1] = 0x14;
		bytes[2] = ble_config.AC_X1000_CMD;
		bytes[3] = ble_config.AC_X1000_CMD_SET_WIFI_SSID;
		for (var i = 0; i < Math.min(15, ssid.length); i++) {
			bytes[4 + i] = ssid.charCodeAt(i);
		}
		bytes[19] = 0x03;
		return data;
	},
	setWifiPasswordCommand2: function(password) {
		if (!password) {
			throw "未设置password";
		}
		let data = new ArrayBuffer(20);
		let bytes = new Uint8Array(data);
		bytes[0] = 0x02;
		bytes[1] = 0x14;
		bytes[2] = ble_config.AC_X1000_CMD;
		bytes[3] = ble_config.AC_X1000_CMD_SET_WIFI_PASS;
		for (var i = 0; i < Math.min(15, password.length); i++) {
			bytes[4 + i] = password.charCodeAt(i);
		}
		bytes[19] = 0x03;
		return data;
	},
	enable4GCommand: function(enabled) {
		let data = new ArrayBuffer(20);
		let bytes = new Uint8Array(data);
		bytes[0] = 0x02;
		bytes[1] = 0x14;
		bytes[2] = ble_config.AC_X1000_CMD;
		bytes[3] = ble_config.AC_X1000_CMD_ENABLE_4G;
		bytes[4] = enabled ? 1 : 0;
		bytes[19] = 0x03;
		return data;
	},
	setMqttServerCommand: function(str) {
		let data = new ArrayBuffer(20);
		let bytes = new Uint8Array(data);
		bytes[0] = 0x02;
		bytes[1] = 0x14;
		bytes[2] = ble_config.AC_SET_MQTT_DOMAIN;
		var domain = str;
		if (domain.length > 16) {
			if (domain.substr(-4) == '.com') {
				domain = domain.substring(0, domain.length - 4) + "1";
			} else if (domain.substr(-4) == '.net') {
				domain = domain.substring(0, domain.length - 4) + "2";
			} else if (domain.substr(-3) == '.cn') {
				domain = domain.substring(0, domain.length - 3) + "3";
			}
		}
		for (var i = 0; i < Math.min(16, domain.length); i++) {
			bytes[3 + i] = domain.charCodeAt(i);
		}
		bytes[19] = 0x03;
		return data;
	},
	setMqttLocalServerCommand: function(ip) {
		var arrIP = ip.split('.');
		if (arrIP.length != 4) throw '不是标准的IPv4格式';
		let data = new ArrayBuffer(20);
		let bytes = new Uint8Array(data);
		bytes[0] = 0x02;
		bytes[1] = 0x14;
		bytes[2] = ble_config.AC_X1000_CMD;
		bytes[3] = ble_config.AC_X1000_CMD_SET_LOCAL_SERVER;
		for (var i = 0; i < 4; i++) {
			bytes[4 + i] = 0xFF & parseInt(arrIP[i], 10);
		}
		bytes[19] = 0x03;
		return data;
	},
	setNetworkModeCommand: function(mode) {
		let data = new ArrayBuffer(20);
		let bytes = new Uint8Array(data);
		bytes[0] = 0x02;
		bytes[1] = 0x14;
		bytes[2] = ble_config.AC_X1000_CMD;
		bytes[3] = ble_config.AC_X1000_CMD_SET_WIFI_MODE;
		bytes[4] = mode & 0xFF;
		bytes[19] = 0x03;
		return data;
	},
	setNetworkTypeCommand: function(type) {
		let data = new ArrayBuffer(20);
		let bytes = new Uint8Array(data);
		bytes[0] = 0x02;
		bytes[1] = 0x14;
		bytes[2] = ble_config.AC_X1000_CMD;
		bytes[3] = ble_config.AC_X1000_CMD_SET_NETWORK_TYPE;
		bytes[4] = type & 0xFF;
		bytes[19] = 0x03;
		return data;
	},
	setNetworkInfoCommand: function(dhcpMode, ip, mask, gateway) {
		var arrIP = ip.split(".");
		var arrMask = mask.split(".");
		var arrGateway = gateway.split(".");
		if (arrIP.length != 4 || arrMask.length != 4 || arrGateway.length != 4) throw '不是标准的IPv4格式';
		let data = new ArrayBuffer(20);
		let bytes = new Uint8Array(data);
		bytes[0] = 0x02;
		bytes[1] = 0x14;
		bytes[2] = ble_config.AC_X1000_CMD;
		bytes[3] = ble_config.AC_X1000_CMD_SET_NETWORK_INFO;
		bytes[4] = dhcpMode & 0xFF;
		for (var i = 0; i < 4; i++) {
			bytes[5 + i] = 0xFF & parseInt(arrIP[i], 10);
			bytes[9 + i] = 0xFF & parseInt(arrMask[i], 10);
			bytes[13 + i] = 0xFF & parseInt(arrGateway[i], 10);
		}
		bytes[19] = 0x03;
		return data;
	},
};
var ble_helper = {
	$cb: {
		onSuccess: null,
		onFail: null,
		rand: null,
		serial: '',
		key: '',
		bindState: 0,
		readerType: 0,
		verified: false,
		onReceiveCard: null,
	},
	$writer: null,
	$received: false,
	$timer: null,
	decode_x: function(str) {
		var key = [7, 28, 33, 30, 1];
		if (str.length > 0 && str.length % 2 == 0) {
			var a = new Uint8Array(str.length / 2);
			var res = "";
			for (var i = 0; i < a.length; i++) {
				a[i] = parseInt(str.substring(i * 2, i * 2 + 2), 16);
				a[i] ^= key[0] | key[4] | key[1] | key[3] | key[2];
				res += String.fromCharCode(a[i]);
			}
			return res;
		}
		return "";
	},
	isMobile: function() {
		var sUserAgent = navigator.userAgent.toLowerCase();
		var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
		var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
		var bIsMidp = sUserAgent.match(/midp/i) == "midp";
		var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
		var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
		var bIsAndroid = sUserAgent.match(/android/i) == "android";
		var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
		var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
		if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
			return true;
		} else {
			return false;
		}
	},
	select: function(options) {
		var that = this;
		that.$cb.onSuccess = options.onSuccess;
		that.$cb.onFail = options.onFail;
		console.log(navigator.bluetooth);
		if (!(navigator && navigator.bluetooth)) {
			that.$cb.onFail('not support');
			return;
		}
		navigator.bluetooth.requestDevice({
			acceptAllDevices: false,
			filters: [{
				namePrefix: 'ework'
			}, {
				namePrefix: 'awork'
			}, ],
			optionalServices: [ble_config.UUID_SERVICE, "alert_notification", "automation_io",
				"battery_service", "blood_pressure", "body_composition", "bond_management",
				"continuous_glucose_monitoring", "current_time", "cycling_power", "cycling_power",
				"cycling_speed_and_cadence", "device_information", "environmental_sensing",
				"generic_access", "generic_attribute", "glucose", "health_thermometer",
				"heart_rate", "human_interface_device", "immediate_alert", "indoor_positioning",
				"internet_protocol_support", "link_loss", "location_and_navigation",
				"next_dst_change", "phone_alert_status", "pulse_oximeter", "reference_time_update",
				"running_speed_and_cadence", "scan_parameters", "tx_power", "user_data",
				"weight_scale"
			]
		}).then(device => {
			that.$cb.onSuccess(device);
		}).catch(error => {
			that.$cb.onFail(error);
		});
	},
	open: function(options) {
		var that = this;
		that.device = options.device;
		that.$cb.onOpenSuccess = options.onSuccess;
		that.$cb.onOpenFail = options.onFail;
		that.$cb.key = that.decode_x(options.key ? options.key : ble_config.VERIFY_KEY);
		if (that.device.gatt.connected) {
			that.$cb.onOpenSuccess();
			return;
		}
		that.device.gatt.connect().then(server => {
			return server.getPrimaryServices();
		}).then(services => {
			return that.overrideServices(services);
		}).catch(error => {
			that.$cb.onOpenFail(error);
		});
	},
	close: function() {
		if (this.device.gatt.connected) {
			this.device.gatt.disconnect();
		}
	},
	init: function() {
		var that = this;
		that.sendRand({
			onSuccess: function() {
				that.verify({
					onSuccess: function() {
						that.$cb.onOpenSuccess({
							serial: that.$cb.serial,
							bindState: that.$cb.bindState,
							readerType: that.$cb.readerType,
						});
					},
					onFail: that.$cb.onOpenFail
				});
			},
			onFail: that.$cb.onOpenFail
		});
	},
	overrideServices: function(services) {
		var that = this;
		let queue = Promise.resolve();
		services.forEach(service => {
			console.log('> Service: ' + service.uuid);
			if (service.uuid.toLowerCase() == ble_config.UUID_SERVICE) {
				queue = queue.then(_ => service.getCharacteristics().then(characteristics => {
					let uuid;
					characteristics.forEach(characteristic => {
						uuid = characteristic.uuid.toLowerCase();
						console.log('> characteristic: ' + uuid);
						if (uuid == ble_config.UUID_NOTIFY) {
							characteristic.startNotifications();
							characteristic.addEventListener(
								'characteristicvaluechanged',
								function(event) {
									const value = event.target.value;
									that.readBluetooth(value.buffer);
								});
						} else if (uuid == ble_config.UUID_WRITE) {
							that.$writer = characteristic;
							if (that.isMobile()) {
								setTimeout(function() {
									that.init();
								}, 300);
							} else {
								that.init();
							}
						}
					});
				}));
			}
		});
		return queue;
	},
	sendRand: function(options) {
		console.log("发送随机数");
		this.$cb.rand = null;
		this.$cb.serial = '';
		this.$cb.onSuccess = options.onSuccess;
		this.$cb.onFail = options.onFail;
		ble_command.writeKeyCommand(this.$cb.key);
		this.writeBluetooth(ble_command.sendRandCommand());
	},
	verify: function(options) {
		console.log("发送设备随机数");
		this.$cb.onSuccess = options.onSuccess;
		this.$cb.onFail = options.onFail;
		this.writeBluetooth(ble_command.verifyCommand(this.$cb.rand, this.$cb.key));
	},
	openDoor: function(options) {
		this.$cb.onSuccess = options.onSuccess;
		this.$cb.onFail = options.onFail;
		var cardId;
		if (typeof(options.cardId) == "string") {
			cardId = options.cardId;
		} else {
			cardId = options.cardId.toString();
		}
		var card = cardId;
		if (card.indexOf("-") != -1) {
			card = card.substring(card.indexOf("-") + 1);
		}
		var prefix = "0000";
		card = parseInt(card, 10).toString(16);
		prefix = parseInt(prefix, 10).toString(16);
		if (card.length < 8) {
			var len = 8 - card.length;
			for (var i = 0; i < len; i++) {
				card = "0" + card;
			}
		}
		if (prefix.length < 4) {
			var len = 4 - prefix.length;
			for (var i = 0; i < len; i++) {
				prefix = "0" + prefix;
			}
		}
		var newCard = "";
		var feature = "";
		for (var i = 8; i > 0; i -= 2) {
			newCard += card.substring(i - 2, i);
		}
		for (var i = 4; i > 0; i -= 2) {
			feature += prefix.substring(i - 2, i);
		}
		console.log("开门数据:" + newCard + "," + feature);
		this.writeBluetooth(ble_command.openDoorCommand(options.isValid, newCard, feature));
	},
	setTime: function(options) {
		this.$cb.onSuccess = options.onSuccess;
		this.$cb.onFail = options.onFail;
		this.writeBluetooth(ble_command.setTimeCommand(options.date));
	},
	bind: function(options) {
		this.$cb.onSuccess = options.onSuccess;
		this.$cb.onFail = options.onFail;
		this.writeBluetooth(ble_command.bindCommand(options.distance, options.type, options.rand, options
			.timezone, options.userData));
	},
	writeParam: function(options) {
		this.$cb.onSuccess = options.onSuccess;
		this.$cb.onFail = options.onFail;
		this.writeBluetooth(ble_command.writeParamCommand(options.inOut, options.openDelay, options.openWay));
	},
	enableBrushCard: function(options) {
		this.$cb.onSuccess = options.onSuccess;
		this.$cb.onFail = options.onFail;
		this.$cb.onReceiveCard = options.onReceiveCard;
		this.writeBluetooth(ble_command.enableBrushCardCommand(options.enabled));
	},
	setWifiSSID: function(options) {
		this.$cb.onSuccess = options.onSuccess;
		this.$cb.onFail = options.onFail;
		this.writeBluetooth(ble_command.setWifiSSIDCommand(options.ssid));
	},
	setWifiPassword: function(options) {
		this.$cb.onSuccess = options.onSuccess;
		this.$cb.onFail = options.onFail;
		this.writeBluetooth(ble_command.setWifiPasswordCommand(options.password));
	},
	setWifiSSID2: function(options) {
		this.$cb.onSuccess = options.onSuccess;
		this.$cb.onFail = options.onFail;
		this.writeBluetooth(ble_command.setWifiSSIDCommand2(options.ssid));
	},
	setWifiPassword2: function(options) {
		this.$cb.onSuccess = options.onSuccess;
		this.$cb.onFail = options.onFail;
		this.writeBluetooth(ble_command.setWifiPasswordCommand2(options.password));
	},
	enable4G: function(options) {
		this.$cb.onSuccess = options.onSuccess;
		this.$cb.onFail = options.onFail;
		this.writeBluetooth(ble_command.enable4GCommand(options.enabled));
	},
	setMqttServer: function(options) {
		this.$cb.onSuccess = options.onSuccess;
		this.$cb.onFail = options.onFail;
		this.writeBluetooth(ble_command.setMqttServerCommand(options.server));
	},
	setMqttLocalServer: function(options) {
		this.$cb.onSuccess = options.onSuccess;
		this.$cb.onFail = options.onFail;
		this.writeBluetooth(ble_command.setMqttLocalServerCommand(options.server));
	},
	setNetworkMode: function(options) {
		this.$cb.onSuccess = options.onSuccess;
		this.$cb.onFail = options.onFail;
		this.writeBluetooth(ble_command.setNetworkModeCommand(options.mode));
	},
	setNetworkType: function(options) {
		this.$cb.onSuccess = options.onSuccess;
		this.$cb.onFail = options.onFail;
		this.writeBluetooth(ble_command.setNetworkTypeCommand(options.type));
	},
	setNetworkInfo: function(options) {
		this.$cb.onSuccess = options.onSuccess;
		this.$cb.onFail = options.onFail;
		this.writeBluetooth(ble_command.setNetworkInfoCommand(options.dhcpMode, options.ip, options.mask,
			options.gateway));
	},
	writeBluetooth: function(buffer) {
		console.log('write', buffer);
		var that = this;
		that.$received = false;
		that.$timer = setTimeout(function() {
			if (!that.$received) {
				that.$cb.onFail('timeout');
			}
		}, 2000);
		that.$writer.writeValue(buffer).catch(error => {
			var str = error.toString();
			console.log(error);
			if (str.indexOf("GATT operation failed") != -1) {
				that.$cb.onFail(str);
			} else if (str.indexOf("GATT operation already") != -1) {
				that.$cb.onFail(str);
			}
		});
	},
	readBluetooth: function(buffer) {
		console.log('read', buffer);
		this.$received = true;
		clearTimeout(this.$timer);
		let result = new ArrayBuffer(16);
		let data = new Uint8Array(buffer);
		var temp = new Uint8Array(result);
		for (var i = 0; i < temp.byteLength; i++) {
			temp[i] = data[i + 3];
		}
		if (data[0] == 0x02 && data.byteLength >= data[1] && data[data[1] - 1] == 0x03) {
			switch (data[2]) {
				case ble_config.CMD_SEND_RAND:
					this.$cb.rand = result;
					this.$cb.serial = "";
					for (var i = 0; i < 4; i++) {
						this.$cb.serial += temp[i + 3] < 10 ? ("0" + temp[i + 3].toString(16)).toUpperCase() :
							temp[i + 3].toString(16).toUpperCase();
					}
					this.$cb.bindState = temp[13] >> 4;
					this.$cb.readerType = temp[13] & 0x0F;
					console.log("设备类型：" + (this.$cb.readerType == 0 ? "门禁" : (this.$cb.readerType == 1 ?
						"WG26读头" : "WG34读头")));
					if (this.$cb.onSuccess) this.$cb.onSuccess();
					return;
				case ble_config.CMD_VERIFY:
					this.$cb.verified = temp[0] != 0;
					console.log("验证" + (this.$cb.verified ? "成功" : "失败"));
					if (this.$cb.verified) {
						if (this.$cb.onSuccess) this.$cb.onSuccess();
					} else {
						if (this.$cb.onFail) this.$cb.onFail();
					}
					return;
				case ble_config.CMD_SET_TIME:
					if (this.$cb.onSuccess) this.$cb.onSuccess();
					return;
				case ble_config.CMD_WRITE_PARAM:
					if (this.$cb.onSuccess) this.$cb.onSuccess(temp[0] > 0);
					return;
				case ble_config.CMD_BIND:
					if (this.$cb.onSuccess) this.$cb.onSuccess(temp[0]);
					return;
				case ble_config.CMD_ENABLE_BRUSH:
					if (this.$cb.onSuccess) this.$cb.onSuccess(temp[0]);
					return;
				case ble_config.CMD_RECEIVE_CARD:
					var card = temp[0] + temp[1] * Math.pow(2, 8) + temp[2] * Math.pow(2, 16) + temp[3] * Math
						.pow(2, 24);
					if (this.$cb.onReceiveCard) this.$cb.onReceiveCard(card);
					return;
				case ble_config.CMD_SET_WIFI_SSID:
					if (this.$cb.onSuccess) this.$cb.onSuccess();
					return;
				case ble_config.CMD_SET_WIFI_PASS:
					if (this.$cb.onSuccess) this.$cb.onSuccess();
					return;
				case ble_config.CMD_OPEN_DOOR:
					if (this.$cb.onSuccess) this.$cb.onSuccess();
					return;
				case ble_config.AC_X1000_CMD:
					if (this.$cb.onSuccess) this.$cb.onSuccess();
					return;
				default:
					break;
			}
		}
		if (this.$cb.onFail) {
			this.$cb.onFail(null);
		}
	}
};
export{
	ble_helper
}
